import { SamplesBasket } from '@df/samples/samples-basket';
import { Resolve } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SamplesLoadBasketResolver implements Resolve<void> {
    constructor(private samplesBasket: SamplesBasket) {}

    resolve(): Promise<void> {
        return this.samplesBasket.load();
    }
}
